<template>
    <div class="subpro">
      <div class="mainBar">
        <div class="rightBar">
          <el-button @click="showAdd = true" class="add">新增</el-button>
            <!-- 新增模态框 -->
              <div class="dial-header">
                <el-dialog :visible.sync="showAdd" class="addTab"  @close="closeDiv" @click="getCity">
                  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
                    <el-form-item label="账号" prop="user_num" class="num">
                      <el-input v-model="ruleForm.user_num" class="user_num"></el-input>
                      <input type="submit" value="">
                    </el-form-item>
                    <el-form-item label="姓名:" prop="name" class="names">
                      <el-input v-model="ruleForm.name" class="name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机:" prop="phone">
                      <el-input v-model="ruleForm.phone" class="phone"></el-input>
                    </el-form-item>
                    <el-form-item label="区域:" prop="areaname" class="areanames">
                      <!-- <el-cascader :options="options" v-model="ruleForm.areaname" class="areaname"></el-cascader>
                    </el-form-item> -->
                      <el-select v-model="area" placeholder="请选择" @change="selectProv"  class="areaname">
                        <el-option
                          v-for="item in options"
                          :key="item.areacode"
                          :label="item.areaname"
                          :value="item.areacode">
                        </el-option>
                      </el-select>
                      <el-select v-model="cityarea" placeholder="请选择" class="cityname">
                        <el-option
                          v-for="item in cities"
                          :key="item.areacode"
                          :label="item.areaname"
                          :value="item.areacode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" id="check" @click="showAdd = false"><div @clic="saleUserPost">支付</div></el-button>
                    </el-form-item>
                  </el-form>
                </el-dialog>
              <!-- <el-dialog :visible.sync="showAdd">
                <div class="searchBar">
                  <span>账号</span>
                  <form action="">
                    <input type="text">
                    <input type="submit" value="" @click="getSaleUser">
                  </form>
                </div>
                <ul class="middle">
                  <li>
                    <span>姓名:</span>
                    <input type="text" class="name"/>
                  </li>
                  <li>
                    <span>手机:</span>
                    <input type="text" class="phone"/>
                  </li>
                  <li>
                    <span>区域:</span>
                    <input type="text" class="areaname"/>
                  </li>
                </ul>
                <div class="bottom">
                  <el-button @click="radioEvent()" id="check">支付</el-button>
                </div>
              </el-dialog> -->
            </div>
        </div>
      </div>
      <div class="main">
        <!-- 列表 -->
        <el-table highlight-current-row  :data="saleUser.slice((
          currentPage-1)*pagesize,currentPage*pagesize)" stripe
          :header-cell-style="{'width':'15.71rem','color':'rgba(79,79,79,1)','text-align':'center','border-bottom':0,'font-weight':'bold'}" @click="getSaleUser">
          <el-table-column prop="name" label="姓名" sortable>
          </el-table-column>
          <el-table-column prop="user_num" label="账号" sortable>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" sortable>
          </el-table-column>
          <el-table-column prop="areaname" label="区域" sortable>
          </el-table-column>
          <el-table-column prop="monthresults" label="当月业绩(元)" sortable>
          </el-table-column>
          <el-table-column prop="allresults" label="总业绩(元)" sortable>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 40]" 
          :page-size="pagesize"  
          layout="total, sizes, prev, pager, next, jumper"
          :total="saleUser.length">  
        </el-pagination>
      </div>
    </div>
</template>
<script>
  import axios from 'axios'
  import $ from 'jquery'
  import {delCookie,getCookie,setCookie} from '@/util/util'
  export default {
   data(){
    return {
      area:'',
      cityarea:'',
      showAdd: false,
      saleUser:[],
      options:[],
      cities:[],
      currentPage:1, //初始页
      pagesize:10, //每页的数据
      ruleForm:{
        name:'',
        user_num:'',
        phone:'',
        authorization:''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        user_num: [
          { required: true, message: '请输入友友号', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/, message:'请输入正确的手机号' }
        ],
        // authorization: [
        //   { required: true, message: '请选择地区', trigger: 'change' }
        // ],
      }
    }
  },
    created(){
      this.getSaleUser();
      this.getProv();
      this.getCity();
      // this.saleUserPost()
    },
    methods:{
      closeDiv(){
        this.$refs['ruleForm'].resetFields()

        // delCookie('areaname')
      },
      // 初始页currentPage、初始每页数据数pagesize和数据data
      handleSizeChange: function (size) {
        this.pagesize = size;
        
        // console.log(this.pagesize)  //每页下拉显示数据
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        // console.log(this.currentPage)  //点击第几页
      },
      // 新增下级代理
      saleUserPost:function(){ 
        var name=$('.name>.el-input__inner').val();
        var user_num=$('.user_num>.el-input__inner').val();
        var phone=$('.phone>.el-input__inner').val();
        // 获取地区
        const url ='/scene/saleUser';
        var params = new URLSearchParams();
        params.append('token', getCookie('session'));
        // 下级代理
        params.append('agent',true);
        params.append('name',name);
        params.append('user_num',user_num);
        params.append('phone',phone);
        // params.append('areaName',areaname);
        this.$axios({
          method: 'post',
          url:url,
          data:params
        }).then((res)=>{
          this.data=res.data;
          // console.log(res.data.retDesc);
        });
      },
      // 获取下级代理列表
      getSaleUser:function(){
        axios.get("/scene/saleUser",{
          params:{
            token:getCookie('session'),
            searchSale:false
          }
        }).then(res => {
          this.data = res.data;
          this.saleUser = res.data.data;
          // console.log(res.data.data);
          
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 获取所有省
      getProv:function(){
        axios.get("/scene/prov",{
        }).then(res => {
          this.data = res.data;
          this.options=res.data.data;
          let prov =JSON.stringify(res.data.data);
          // console.log(prov);
        }).catch((err)=>{
          console.log(err);
        })
      },
      //省下拉框选中事件
      selectProv(value){//这个就是value值
        let obj = {};
        obj = this.options.find((item)=>{//这里的userList就是上面遍历的数据源
          return item.areacode === value;//筛选出匹配数据
        });
        // 获取省编码
        let expireDays = 1000 * 60 * 60 ;
        setCookie('areacode',obj.areacode,expireDays);
        // console.log(obj.areacode);
      },
      // 获取所有市
      getCity:function(){
        axios.get("/scene/city",{
           params:{
            provCode:getCookie('areacode')
          }
        }).then(res => {
          this.data = res.data;
          this.cities=res.data.data;
          // console.log(res.data.data)
        }).catch((err)=>{
          console.log(err);
        })
      },
   }
  }
</script>
<style scoped lang="scss">
  .mainBar{
    width:15.71rem;
    height:0.53rem;
    background:rgba(255,255,255,1); 
  }
  .mainBar span{
    float: left;
    height:0.15rem;
    font-size:0.16rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(79,79,79,1);
    line-height:0.53rem;
  }
  .mainBar span:nth-of-type(1){
    margin-left: 0.14rem;
  }
  .mainBar span:nth-of-type(2){
    margin-left: 0.61rem;
  }
  .mainBar span:nth-of-type(3){
    width:0.12rem;
    height:0.04rem;
    font-size:0.14rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(192,190,190,1);
  }
  .mainBar form>input{
    float: left;
    width:1.99rem;
    height:0.28rem;
    border:0.01rem solid rgba(196,196,196,1);
    margin: 0.13rem 0 0.12rem 0.07rem;
    text-indent: 0.06rem;
  }
  .leftBar{
    float: left;
  }
  .rightBar{
    float: right;
  }
  .rightBar input{
    width:0.98rem;
    height:0.28rem;
    border:0.01rem solid rgba(196,196,196,1);
  }
  .rightBar input:nth-of-type(2){
    margin-right: 0.1rem;
  }
  input::-webkit-input-placeholder{
    font-size:0.14rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(192,190,190,1);
    line-height:0.28rem;
  }
  .main{
    width:15.71rem;
    /*height:8.41rem;*/
    margin-top: 0.12rem;
    background:rgba(255,255,255,1);
  }
  .searchBar{
    float: left;
    width: 4.23rem;
    height: 0.7rem;
    border-bottom: 0.02rem solid #AEAFAF;
  }
  .mainBar .searchBar>span{
    height:0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(76,76,76,1);
    line-height:0.18rem;
    margin-top: 0.26rem;
    margin-left: 0.5rem;
  }
  .searchBar>form{
    width: 2.4rem;
    height: 0.38rem;
    border:0.01rem solid rgba(191,191,191,1);
    border-radius:0.08rem;
    margin: 0.17rem 0 0 1rem;
  }
  .searchBar>form input[type='text']{
    width:1.95rem;
    height:0.32rem;
    vertical-align: top;
    text-indent: 0.09rem;
    margin-top: 0.04rem;
    border:0;
  }
  .searchBar>form input[type='submit']{
    width: 0.19rem;
    height: 0.19rem;
    background: url('../assets/img/search.png');
    background-size: 0.19rem 0.19rem;
    margin-top: 0.09rem;
    border:0;
  }
  .middle{
    float: left;
    width: 4.23rem;
    height: 1.83rem;
    padding: 0.3rem 0 0 0.85rem;
    border-bottom: 0.02rem solid #AEAFAF;
  }
  .middle>li{
    height:0.18rem;
    line-height: 0.28rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(21,21,21,1);
    margin-bottom: 0.32rem;
  }
  .middle>li>span{
    float: left;
    line-height: 0.28rem;
    height:0.18rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(76,76,76,1);
    letter-spacing: 0.1rem;
  }
  .middle>li>input[type="text"]{
    text-indent: 0.05rem;
    float: left;
    display: inline-block;
    font-weight:300;
    color:rgba(21,21,21,1);
    line-height: 0.3rem;
    width: 1.6rem;
    height:0.28rem;
    font-size:0.18rem;
  }
</style>
<style>
  .subpro .addTab .areaname .el-input{
    width: 1.6rem;
  }
  .subpro .addTab .areaname .el-input__icon{
    line-height: 0.32rem;
  }
  .subpro .addTab .cityname .el-input{
    width: 1.6rem;
  }
  .subpro .addTab .cityname .el-input__icon{
    line-height: 0.32rem;
  }
  .subpro .addTab .el-form-item__error{
    width: 5rem;
    text-align: center;
  }
  .subpro .ruleForm input[type='submit']{
    position: relative;
    left: -0.34rem;
    width: 0.19rem;
    height: 0.19rem;
    background: url('../assets/img/search.png');
    background-size: 0.19rem 0.19rem;
    margin-top: 0.09rem;
    border:0;
  }
  .subpro .el-dialog__headerbtn{
    display: none;
  }
  .subpro .addTab .el-input{
    line-height: 0.32rem;
    width: 1.6rem;
    height: 0.4rem;
  }
  .subpro .addTab .el-input .el-input__inner{
    line-height: 0.32rem;
    width: 1.5rem;
    height: 0.4rem;
    border:0;
    border-bottom:0.01rem solid rgba(181,181,181,1);
    border-radius:0;
    padding: 0 0.1rem;
  }
  .subpro .addTab .names{
    padding: 0.25rem 0 0.25rem 0;
  }
  .subpro .addTab .areanames{
    padding: 0.25rem 0 0.25rem 0;
    border-bottom: 0.02rem solid #AEAFAF;
  }
  .subpro .addTab .user_num{
    width: 2.4rem;
    height: 0.4rem;
  }
  .subpro .addTab .user_num .el-input__inner{
    width: 2.4rem;
    height: 0.4rem;
    border:0.01rem solid rgba(181,181,181,1);
    border-radius:0.08rem;
    padding: 0 0.1rem;
  }
  .subpro .addTab .areaname{
    width: 1.6rem;
    height: 0.4rem;
  }
  .subpro .addTab .areaname .el-input__inner{
    width: 1.6rem;
    height: 0.4rem;
    border:0.01rem solid rgba(181,181,181,1);
    border-radius:0.08rem;
    padding: 0 0.1rem;
  }
  .subpro .addTab .cityname{
    width: 1.5rem;
    height: 0.4rem;
  }
  .subpro .addTab .cityname .el-input__inner{
    width: 1.5rem;
    height: 0.4rem;
    border:0.01rem solid rgba(181,181,181,1);
    border-radius:0.08rem;
    padding: 0 0.1rem;
  }
  .subpro .addTab .el-form-item__label{
    letter-spacing: 0.1rem;
  }
  .subpro .addTab .el-form-item{
    margin-bottom: 0;
  }
  .subpro .addTab .el-form-item__label{
    margin-left: 0.9rem;
    padding: 0 0.05rem 0 0;
  }
  .subpro .addTab .num{
    margin-top: 0.15rem;
    padding-bottom: 0.3rem;
    border-bottom: 0.02rem solid #AEAFAF;
  }
  .subpro .addTab .num>.el-form-item__label{
    margin-left: 0.5rem;
  }
  .cell{
    text-align: center;
  }
  .subpro .mainBar>.rightBar>.el-button{
    width:0.75rem;
    height:0.30rem;
    background:rgba(244,57,65,1);
    border-radius:0.15rem;
    color: #fff;
    margin: 0.1rem 0.3rem 0 0;
  }
  .subpro .el-dialog__header{
    padding-top: 0;
  }
  .subpro .el-dialog__headerbtn{
    top: 0.05rem;
    right: 0.1rem;
  }
  .subpro .el-dialog__body{
    padding: 0;
  }
  .subpro .el-dialog{
    width: 5.2rem;
    height: 4.7rem;
    border-radius:0.12rem;
  }
  .subpro #check{
    width:1.68rem;
    height:0.45rem;
    background:rgba(244,57,65,1);
    border-radius:0.08rem;
    border: 0; 
    color: #fff;
    margin: 0 0 0 1.8rem;
    letter-spacing: 0.1rem;
    font-size: 0.18rem;
  }
  .subpro #check span{
    margin-left: 0.2rem;
  }  
</style>





// WEBPACK FOOTER //
// src/views/subpro.vue